import { render, staticRenderFns } from "./UrlRedirectModeForm.vue?vue&type=template&id=59bb4095&scoped=true&"
import script from "./UrlRedirectModeForm.vue?vue&type=script&lang=ts&"
export * from "./UrlRedirectModeForm.vue?vue&type=script&lang=ts&"
import style0 from "./UrlRedirectModeForm.vue?vue&type=style&index=0&id=59bb4095&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bb4095",
  null
  
)

export default component.exports